import { render, staticRenderFns } from "./FleetDetail.vue?vue&type=template&id=1ce0ac98&scoped=true"
import script from "./FleetDetail.vue?vue&type=script&lang=ts"
export * from "./FleetDetail.vue?vue&type=script&lang=ts"
import style0 from "./FleetDetail.vue?vue&type=style&index=0&id=1ce0ac98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce0ac98",
  null
  
)

export default component.exports